import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { t } from "@/i18n/pl";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <p className="text-primary text-6xl font-bold tabular-nums">404</p>
      <h1 className="text-xl font-semibold">{t.common.notFoundTitle}</h1>
      <p className="text-muted-foreground text-sm">{t.common.notFoundBody}</p>
      <Button asChild variant="outline">
        <Link to="/">{t.common.goHome}</Link>
      </Button>
    </div>
  );
}
